import Link from 'next/link';
import { ProjectElementSchema } from '../../schema/pageElements.val';
import HotspotImage from '../HotspotImage';
import ProjectClient from './ProjectClient';
import ProjectServices from './ProjectServices';
import ProjectTitle from './ProjectTitle';

interface ProjectElementProps extends ProjectElementSchema {
  priority?: boolean;
  isRectangular?: boolean;
}

const ProjectElement = ({
  image,
  projectTitle,
  isRectangular = false,
  priority = false,
  clientName,
  url,
  services,
}: ProjectElementProps) => {
  const aspectRatio = isRectangular
    ? 'aspect-[1/1.6] w-full' // Rectangular image (taller)
    : 'aspect-square w-full'; // Square image

  return (
    <div className={`flex flex-col justify-center h-full group`}>
      <ProjectClient clientName={clientName} />
      <ProjectTitle title={projectTitle} />
      <Link href={url} className={`w-full relative overflow-hidden`}>
        <div className="transform transition-transform duration-1000 ease-spring hover:scale-105">
          {image && (
            <HotspotImage
              image={image}
              setAspectRatio={aspectRatio}
              priority={priority}
            />
          )}
          <div className="absolute inset-0 bg-white opacity-0 duration-1000 ease-spring group-hover:opacity-[0.03] pointer-events-none z-10" />
        </div>
      </Link>
      <ProjectServices services={services} />
    </div>
  );
};

export default ProjectElement;
